import { createSelector } from 'reselect'

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export default () => createSelector(
  [
    getBoardId,
    getIsArchived
  ],
  (
    boardId,
    isArchived
  ) => ({
    boardId,
    isArchived
  })
)
